/******/ (() => { // webpackBootstrap
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsDrawer = this.closest('[data-cart-drawer-recommendations]');
    this.fetchRecommendations = this.fetchRecommendations.bind(this);
    this.renderRecommendations = this.renderRecommendations.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-recommendations'});

    // A deferred instance ships with no markup at all: its rail is fetched on first drawer open
    // rather than sitting inside a closed drawer in front of the LCP element on every page.
    // See snippets/cart-drawer.liquid and sections/cart-drawer-empty-recommendations.liquid.
    if (!this.hasAttribute('data-cart-recommendations-defer')) {
      this.fetchRecommendations();
      return;
    }

    const drawer = this.closest('cart-drawer');

    // The rail sits inside [data-cart-dynamic-content="cart-body"], which component-cart-drawer.js
    // replaces wholesale on every cart update. So a deferred instance can be created while the
    // drawer is ALREADY open, after drawer:opened has fired -- fetch immediately in that case, or
    // the rail would stay empty for the rest of the session.
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
      this.fetchRecommendations();
      return;
    }

    // No event bus means no open signal to wait for; fall back to the original behaviour rather
    // than never rendering.
    if (!window.eventBus || typeof window.eventBus.on !== 'function') {
      this.fetchRecommendations();
      return;
    }

    this.onDrawerOpened = (opened) => {
      if (drawer && opened !== drawer) return;
      if (this.hasFetched) return;
      this.hasFetched = true;
      this.fetchRecommendations();
    };
    window.eventBus.on('drawer:opened', this.onDrawerOpened);
  }

  disconnectedCallback() {
    // Cart updates discard and rebuild this element, so an un-removed listener would accumulate
    // one closure per cart change for the life of the page.
    if (this.onDrawerOpened && window.eventBus && typeof window.eventBus.off === 'function') {
      window.eventBus.off('drawer:opened', this.onDrawerOpened);
    }
  }

  async fetchRecommendations() {
    if (!this.url) return;
 
    try {
      const response = await fetch(this.url);
      
      if (response.ok) {
        const responseText = await response.text();
        this.renderRecommendations(responseText);
      }
    } catch (error) {
      console.error(`Failed to fetch cart drawer:`, error);
    }
  }

  renderRecommendations(html) {
    const updatedContent = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-recommendations')?.innerHTML;
    
    if (!updatedContent || updatedContent.trim().length === 0) {
      /* ===== If no recommendations, hide the secondary drawer ===== */
      this.closest('cart-drawer')?.classList.add('hide-recommendations');
    } else {
      /* ===== If recommendations, update content ===== */
      this.innerHTML = updatedContent;
      this.closest('cart-drawer')?.classList.remove('hide-recommendations');

      /* ===== Prevent mobile content shift with each fetch by fixing the parent height and re-calculating after each fetch ===== */
      if (window.matchMedia('only screen and (max-width: 767px)').matches) {
        this.parentElement.style.height = 'auto';
        this.parentHeight = this.parentElement.getBoundingClientRect().height;
        this.parentElement.style.height = '';
        document.documentElement.style.setProperty('--cart-recommendations-height', `${this.parentHeight}px`);
      }
    }
  }

  get url() {
    return this.getAttribute('data-cart-recommendations-url');
  }
}

customElements.define('cart-recommendations', CartRecommendations);
/******/ })()
;